import axios from 'axios';

// Экземпляр для публичных маршрутов (без токена)
export const publicAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Экземпляр для приватных маршрутов (с токеном)
export const privateAPI = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Перехватчик для приватных запросов с токеном
privateAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Перехватчик для обработки ответов с истекшим токеном
privateAPI.interceptors.response.use(response => response, async error => {
  const originalRequest = error.config;
  const refreshToken = localStorage.getItem('refresh_token');

  if (error.response.status === 401 && !originalRequest._retry && refreshToken) {
    originalRequest._retry = true;
    try {
      const refreshResponse = await axios({
        method: 'post',
        url: `${error.config.baseURL}/auth/refresh`,
        headers: {
          Authorization: `Bearer ${refreshToken}`
        }
      });

      localStorage.setItem('access_token', refreshResponse.data.access_token);
      originalRequest.headers['Authorization'] = `Bearer ${refreshResponse.data.access_token}`;

      return privateAPI(originalRequest);
    } catch (refreshError) {
      if (refreshError.response && refreshError.response.status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login?session=expired';
      }
      return Promise.reject(refreshError);
    }
  }

  if (!refreshToken) {
    localStorage.removeItem('access_token');
    window.location.href = '/login?session=expired';
  }

  return Promise.reject(error);
});